import { Injectable } from '@angular/core';
import { get, save } from 'src/app/data/utils/localstorage.util';

@Injectable({
	providedIn: 'root',
})
export class LocalStorageService {
	constructor() {}

	save<T>(key: string, value: T): void {
		save<T>(key, value);
	}

	get<T>(key: string): T | null {
		return get<T>(key);
	}
}
